var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundon01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "M2.5 7.86H6L12.5 3v18l-7-4.864h-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M15.593 9.18a3.7 3.7 0 0 1 1.403 2.9 3.7 3.7 0 0 1-1.31 2.825l1.19 1.085a5.29 5.29 0 0 0 1.72-3.91c0-1.59-.7-3.017-1.81-3.988zm3.419 8.757 1.184 1.08a9.47 9.47 0 0 0 2.8-6.736 9.48 9.48 0 0 0-3.102-7.022l-1.188 1.083a7.88 7.88 0 0 1 2.69 5.939 7.88 7.88 0 0 1-2.384 5.656",
  clipRule: "evenodd"
})));
export default SvgIconSoundon01;